import { gql } from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * The AWSDateTime scalar type provided by AWS AppSync, representing a valid extended ISO 8601 DateTime
   * string of the form YYYY-MM-DDThh:mm:ss.SSSZ. The time zone offset is compulsory.
   */
  AWSDateTime: { input: any; output: any; }
  /** A JSON string, provided by AWS AppSync. Used for a process's free-form `data` map. */
  AWSJSON: { input: any; output: any; }
};

export type BrowseInput = {
  endpointId: Scalars['ID']['input'];
  /** Share-relative folder, / for the root. */
  path: Scalars['String']['input'];
};

/** A share on an Aspera Shares server, or an Aspera server reached directly (content_aspera/endpoints.py). */
export type Endpoint = {
  __typename?: 'Endpoint';
  /**
   * Whether `browse` can list it: a Shares endpoint this environment exports to or imports from. Not a direct server
   * (no listing without Shares), and not an endpoint unused here (its credentials for this environment need not exist).
   */
  browsable: Scalars['Boolean']['output'];
  /**
   * How it is listed when browsable: false = `browse` answers directly (Shares); true = `startBrowse` returns a process
   * whose data carries the entries once it ends (a direct server, listed from its fixed egress address).
   */
  browseAsync: Scalars['Boolean']['output'];
  /** The Elastic IP transfers to this endpoint come from, when its server allowlists sources. Null otherwise. */
  fixedEgressIp?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** What the endpoint is reached at: the Shares URL, or host:port of a direct server. */
  server: Scalars['String']['output'];
  /** The share on that server; null for a direct server. */
  shareId?: Maybe<Scalars['Int']['output']>;
  /** The Shares URL; null for a direct server. */
  sharesUrl?: Maybe<Scalars['String']['output']>;
  /** The stored login, as signiant's Portal.status. Read from the secret, without logging in to the share. */
  status: SessionStatus;
  /** Set when this endpoint takes exports in this environment. */
  upload?: Maybe<UploadCapability>;
};

export type EndpointProcessesInput = {
  endpointId: Scalars['ID']['input'];
  /** Newest first; at most this many (default 50, at most 200). */
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type EndpointRefInput = {
  endpointId: Scalars['ID']['input'];
};

/** One row of a share folder. */
export type Entry = {
  __typename?: 'Entry';
  name: Scalars['String']['output'];
  /** Share-relative path, usable as the next `path` for a directory. */
  path: Scalars['String']['output'];
  /** file | directory */
  type: Scalars['String']['output'];
};

export type ExportInput = {
  endpointId: Scalars['ID']['input'];
  /** Key of the object under the endpoint's upload source. */
  key: Scalars['String']['input'];
  /** The object version to send: the one that was published, not whatever is current when the worker starts. */
  versionId: Scalars['String']['input'];
};

export type LoginInput = {
  endpointId: Scalars['ID']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  /** Tried against the share first, and stored in the endpoint's secret only when the share accepts it. */
  username?: InputMaybe<Scalars['String']['input']>;
};

export type LoginPayload = {
  __typename?: 'LoginPayload';
  endpoint?: Maybe<Endpoint>;
  message?: Maybe<Scalars['String']['output']>;
  /** The check's process while VERIFYING; null otherwise. */
  process?: Maybe<Process>;
  status: LoginStatus;
};

export enum LoginStatus {
  Failed = 'FAILED',
  LoggedIn = 'LOGGED_IN',
  MfaRequired = 'MFA_REQUIRED',
  /** No username/password stored yet — supply them once on `login`. */
  NoCredentials = 'NO_CREDENTIALS',
  /** A direct server's login is being checked from its fixed address: poll `process`; it is stored only if accepted. */
  Verifying = 'VERIFYING'
}

export type Mutation = {
  __typename?: 'Mutation';
  /** Send one object version to the endpoint. Returns the export process. */
  export: Process;
  /** Check the stored login, or replace it with the given one once the share accepts it. */
  login: LoginPayload;
  /**
   * List one folder of a direct server, from its fixed egress address. Returns a process; poll `process` until it ends:
   * data.entries (name, path, type, size, modified), data.method (sftp or ascmd), data.truncated.
   */
  startBrowse: Process;
  /**
   * Start a fixed-IP endpoint's worker ahead of use and hold it for 30 minutes after the last start. Idempotent: a
   * second call only extends the hold; it never starts a second instance.
   */
  startWorker: WorkerStatus;
  submit_mfa: LoginPayload;
};


export type MutationExportArgs = {
  input: ExportInput;
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationStartBrowseArgs = {
  input: BrowseInput;
};


export type MutationStartWorkerArgs = {
  input: EndpointRefInput;
};


export type MutationSubmit_MfaArgs = {
  input: SubmitMfaInput;
};

export type Process = {
  __typename?: 'Process';
  /** The process data map, as JSON. */
  data?: Maybe<Scalars['AWSJSON']['output']>;
  endDate?: Maybe<Scalars['AWSDateTime']['output']>;
  endpointId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['AWSDateTime']['output'];
  /** IN_PROGRESS | SUCCESS | FAILED */
  state: Scalars['String']['output'];
};

export type ProcessRefInput = {
  processId: Scalars['ID']['input'];
};

export type Query = {
  __typename?: 'Query';
  /** One folder of the share, every page of it. */
  browse: Array<Entry>;
  endpoint?: Maybe<Endpoint>;
  /**
   * Every endpoint this caller may use. Takes no arguments, like signiant's `portals`: the list is confined by the
   * caller's own policies (their `input.endpointId` conditions), never by anything the client sends.
   */
  endpoints: Array<Endpoint>;
  process?: Maybe<Process>;
  /** The endpoint's transfer processes, newest first. */
  processes: Array<Process>;
  /** The worker of an endpoint with a fixed egress address (Delta DFP); null for any other endpoint. */
  workerStatus?: Maybe<WorkerStatus>;
};


export type QueryBrowseArgs = {
  input: BrowseInput;
};


export type QueryEndpointArgs = {
  input: EndpointRefInput;
};


export type QueryProcessArgs = {
  input: ProcessRefInput;
};


export type QueryProcessesArgs = {
  input: EndpointProcessesInput;
};


export type QueryWorkerStatusArgs = {
  input: EndpointRefInput;
};

export type SessionStatus = {
  __typename?: 'SessionStatus';
  /** Shares sessions last one call; always null here, kept for an endpoint with longer sessions. */
  expiresAt?: Maybe<Scalars['AWSDateTime']['output']>;
  /** A login is stored. It was accepted by the share when it was stored (see message). */
  loggedIn: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  /** Always false for Shares today; the seam for an endpoint that asks for MFA. */
  needsMfa: Scalars['Boolean']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export type SubmitMfaInput = {
  code: Scalars['String']['input'];
  endpointId: Scalars['ID']['input'];
};

export type UploadCapability = {
  __typename?: 'UploadCapability';
  /** Share-relative folder exports land below: / in prod, /test elsewhere. */
  remoteRoot: Scalars['String']['output'];
  /** s3:// URI of the bucket and prefix exports are taken from. */
  source: Scalars['String']['output'];
};

/**
 * A fixed-IP endpoint's worker: OFF (the group at zero), STARTING (an instance launching, or its address not yet
 * attached), READY (in service on its fixed address, idle), BUSY (a transfer holds it).
 */
export enum WorkerState {
  Busy = 'BUSY',
  Off = 'OFF',
  Ready = 'READY',
  Starting = 'STARTING'
}

export type WorkerStatus = {
  __typename?: 'WorkerStatus';
  /** The fixed address the worker uses. */
  egressIp?: Maybe<Scalars['String']['output']>;
  /** What holds it while BUSY: the process kind and id. */
  heldBy?: Maybe<Scalars['String']['output']>;
  /** The end of a Start-worker hold; null when none runs. */
  holdUntil?: Maybe<Scalars['AWSDateTime']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  /** Since when it is in this state, where known: the instance's launch, or the running transfer's start. */
  since?: Maybe<Scalars['AWSDateTime']['output']>;
  state: WorkerState;
};
